export default __webpack_public_path__ + "static/about-block-1-a2851428cc8728766742d66a00d0d0f2.jpg";